import { call, put, select, takeEvery, takeLatest } from 'redux-saga/effects'
import { api } from '../services/api'
import { logRavenError, setUserContext } from '../services/raven'
import { publishTracking } from '../services/tracking'
import {
  LOGIN_PENDING,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  CHANGE_AUTH_STATE,
  INIT_SESSION_CALL,
  INIT_SESSION_CALL_SUCCESS,
  INIT_SESSION_CALL_FAIL,
} from '../actions/index'
import constants from '../constants/index'
import sendPostMessage from '../services/post-communication'

function* onLogin(action) {
  const { payload } = action

  try {
    const user = yield call(api.login, payload)
    yield put({ type: LOGIN_SUCCESS, payload: user })
    yield put({ type: CHANGE_AUTH_STATE, payload: user.data })

    if (!payload.isRedirectFlow) {
      yield call(sendPostMessage, {
        ...user.data,
        rememberPassword: action.payload.rememberPassword,
        ...constants.USER_ACTIONS.login,
        loginMethod: 'email',
      })

      publishTracking({
        clientId: user.data.gigya_id,
        userAction: 'sign in',
        origin: 'time out',
        event: 'event44',
      })
    }

    yield call(setUserContext, { email: user.data.email })
  } catch (e) {
    yield put({ type: LOGIN_FAIL, payload: e.response })
    // scrub sensitive data from error before sending it to sentry
    delete e.response.config.data
    yield call(logRavenError, 'Sign in error', e, e.response)

    if (!payload.isRedirectFlow) {
      publishTracking({
        userAction: 'login error',
        origin: 'time out',
        event: 'event147',
      })
    }
  }
}

function* onLogout() {
  yield call(api.logout)
  yield call(sendPostMessage, { ...constants.USER_ACTIONS.logout })
}

function* onSessionCall({payload}) {
  try {
    const {accessToken} = payload;

    const sessionData = yield call(api.sessionInfo, {access_token: accessToken, method: 'access_token'});

    yield put({ type: INIT_SESSION_CALL_SUCCESS, payload: sessionData })
  } catch (e) {
    yield put({ type: INIT_SESSION_CALL_FAIL, payload: e.message })
  }
}

export function* initSession() {
  yield takeEvery(INIT_SESSION_CALL, onSessionCall);
}

export function* login() {
  yield takeEvery(LOGIN_PENDING, onLogin)
}

export function* logout() {
  yield takeEvery(LOGOUT, onLogout)
}



// WEBPACK FOOTER //
// ./src/sagas/session.js